import React from 'react';
import ParameterControl from './ParameterControl';

const ParameterGroup = ({
  group,
  values,
  onChange,
  disabled,
  hideHeader = false,
  constraints = {},
  excludeControlIds = [],
}) => {
  if (!group || !group.controls || group.controls.length === 0) {
    return null;
  }

  const excluded = new Set(Array.isArray(excludeControlIds) ? excludeControlIds : []);
  const controlsToRender = group.controls.filter((control) => !excluded.has(control.id));
  if (controlsToRender.length === 0) {
    return null;
  }

  const classNames = ['parameter-group'];
  if (hideHeader) {
    classNames.push('parameter-group--compact');
  }
  if (group.kind && group.kind !== 'section') {
    classNames.push(`parameter-group--${group.kind}`);
  }

  return (
    <section className={classNames.join(' ')}>
      {!hideHeader && (
        <header className="parameter-group__header">
          <h3>{group.title}</h3>
          {group.description ? <p>{group.description}</p> : null}
        </header>
      )}
      <div className="parameter-group__controls">
        {controlsToRender.map((control) => (
          <ParameterControl
            key={control.id}
            control={control}
            value={values?.[control.id] ?? control.defaultValue ?? ''}
            onChange={onChange}
            disabled={disabled}
            constraint={constraints?.[control.id]}
          />
        ))}
      </div>
    </section>
  );
};

export default ParameterGroup;
